import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle';

import { useApplication } from '../AppContext';

const About = () => {
	const app = useApplication();
	const { t } = useTranslation();

	const showSendEmail = app.config.showSendEmail;
	const showMoreGames = app.showMoreGames;
	const showRateGame = app.config.showRateGame;

	const rateGame = React.useCallback(() => {
		app.rateGame();
	}, [app]);

	const share = React.useCallback(() => {
		app.share();
	}, [app]);

	const email = React.useCallback(() => {
		app.email();
	}, [app]);

	const moreGames = React.useCallback((event) => {
		event.preventDefault();
		app.navigate('MoreGames');
	}, [app]);

	return (<div id="About1" className="page1">
		<div className="wrapper">
			<PageTitle>
				<h1>{t('About')}</h1>
			</PageTitle>
			{showSendEmail && (
				<div>
					<a onClick={email} className="list-button">
						<i className="ui-icon ui-mail" />
						{t('Send Feedback')}
					</a>
				</div>
			)}
			{showRateGame && (
				<div>
					<a onClick={rateGame} className="list-button" >
						<i className="ui-icon ui-favs" />
						{t('Rate Game')}
					</a>
				</div>
			)}
			<div>
				<a onClick={share} className="list-button" >
					<i className="ui-icon ui-share" />
					{t('Share')}
				</a>
			</div>
			{showMoreGames && (
				<div>
					<a href="#MoreGames" className="list-button" onClick={moreGames}>
						<i className="ui-icon ui-game" />
						{t('More Games')}
					</a>
				</div>
			)}
			<div className="text-center">
				{app.config.email}
			</div>
			
		</div>
	</div>
	);
};

export default React.memo(About);
